import React from 'react';
import ContentLoader from 'react-content-loader';
import {isRTL} from '../../../../Localization';

type Props = {
    className?: string;
};

export const Loader = (props: Props) => (
    <ContentLoader
        speed={5}
        width={450}
        height={1080}
        viewBox="0 0 450 1080"
        backgroundColor="#f4f6f8"
        foregroundColor="#dee7eb"
        rtl={isRTL()}
        {...props}
    >
        <rect x="30" y="20" rx="3" ry="3" width="69" height="12" />
        <rect x="30" y="40" rx="3" ry="3" width="180" height="30" />
        <rect x="30" y="80" rx="3" ry="3" width="69" height="12" />
        <rect x="30" y="140" rx="3" ry="3" width="180" height="24" />
        <rect x="30" y="179" rx="3" ry="3" width="100" height="100" />
        <rect x="0" y="120" rx="3" ry="3" width="450" height="1" />
        <rect x="250" y="205" rx="3" ry="3" width="90" height="16" />
        <rect x="250" y="230" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="305" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="330" rx="3" ry="3" width="180" height="16" />
        <rect x="250" y="305" rx="3" ry="3" width="90" height="16" />
        <rect x="250" y="330" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="365" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="390" rx="3" ry="3" width="180" height="16" />
        <rect x="250" y="365" rx="3" ry="3" width="90" height="16" />
        <rect x="250" y="390" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="430" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="455" rx="3" ry="3" width="180" height="16" />
        <rect x="0" y="520" rx="3" ry="3" width="450" height="1" />
        <rect x="30" y="540" rx="3" ry="3" width="90" height="24" />
        <rect x="30" y="580" rx="3" ry="3" width="90" height="16" />
        <rect x="130" y="580" rx="3" ry="3" width="90" height="16" />
        <rect x="240" y="580" rx="3" ry="3" width="90" height="16" />
        <rect x="350" y="580" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="623" rx="3" ry="3" width="410" height="24" />
        <rect x="30" y="663" rx="3" ry="3" width="410" height="24" />
        <rect x="30" y="706" rx="3" ry="3" width="410" height="24" />
        <rect x="30" y="749" rx="3" ry="3" width="410" height="24" />
        <rect x="0" y="795" rx="3" ry="3" width="450" height="1" />
        <rect x="30" y="816" rx="3" ry="3" width="180" height="24" />
        <rect x="30" y="847" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="873" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="914" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="940" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="981" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="1007" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="1048" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="1074" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="1115" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="1141" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="1182" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="1208" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="1249" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="1275" rx="3" ry="3" width="180" height="16" />
        <rect x="30" y="1316" rx="3" ry="3" width="90" height="16" />
        <rect x="30" y="1342" rx="3" ry="3" width="180" height="16" />
        <rect x="250" y="847" rx="3" ry="3" width="90" height="16" />
        <rect x="250" y="873" rx="3" ry="3" width="295" height="211" />
    </ContentLoader>
);
